import {
    getDataApi,
    postDataApi,
    putDataApi,
    deleteDataApi,
} from '../utils/fech-api';

const BASE_URL_MANAGE = '/api/admin/articles'; 
const BASE_URL_GET = '/api/articles'; 
const BASE_URL_SUPADMIN = '/api/supadmin/articles';

// Fetch all articles
export const fetchArticles = async (params = {}, headers = {}) => {
    return await getDataApi(BASE_URL_GET, {...headers, Accept: 'application/ld+json',}, params);
};

// Fetch a single article by ID
export const fetchArticleById = (articleId, headers = {}) => {
    return getDataApi(`${BASE_URL_GET}/${articleId}`, headers);
};

// Create a new article
export const createArticle = (articleData, headers = {}) => {
    return postDataApi(BASE_URL_MANAGE,articleData, headers);
};

// Update an article (PUT request)
export const updateArticle = (articleId, updatedData, headers = {}) => {
    console.log(articleId, updatedData);
    return putDataApi(`${BASE_URL_MANAGE}/${articleId}`, updatedData, headers);
};


// Partially update an article (PATCH request - status update)
export const updateArticleStatus = (articleId, status, headers = {}) => {
    return putDataApi(`${BASE_URL_SUPADMIN}/${articleId}`, { status }, headers);
};


// Delete an article
export const deleteArticle = (articleId, headers = {}, params = {}) => {
    return deleteDataApi(`${BASE_URL_MANAGE}/${articleId}`, headers, params);
};
